import { Node } from "@tiptap/core"

export const YouTubeExtension = Node.create({
  name: "youTubeVideo",
  group: "block",
  inline: false,
  selectable: true,
  atom: true,

  addAttributes() {
    return {
      src: { default: null }
    }
  },

  parseHTML() {
    return [
      {
        tag: "div.video-embed-iframe",
        getAttrs: (dom) => ({
          src: dom.querySelector("iframe")?.getAttribute("src")
        })
      }
    ]
  },

  renderHTML({ HTMLAttributes }) {
    return [
      "div",
      { class: "video-embed-iframe pb-[56.25%] w-full h-0 relative" },
      [
        "iframe",
        {
          ...HTMLAttributes,
          style: "position: absolute; top: 0; right: 0; bottom: 0; left: 0; z-index: 0; width: 100%; height: 100%;",
          allowfullscreen: "true",
          frameborder: "0"
        }
      ]
    ]
  },

  addCommands() {
    return {
      setYouTubeVideo: (attributes) => ({ commands }) => {
        return commands.insertContent({ type: "youTubeVideo", attrs: attributes })
      }
    }
  }
})
